<template>
  <van-row justify="center" class="page-wrapper">
    <van-col span="24" class="mt-25 place-content-center flex-display-fix">
      <send-indications-info-part />
      <info-message class="round-shadow apply-loader add-account-page-message">
        {{ $t("regionalEnergy.sendIndications.sendIndicationInfo") }}
      </info-message>
      
      <!-- Форма для ввода показаний счетчика -->
      <api-naftogaz-tariffmax-form />

      <div class="donora-indications-action">
        <button class="donora-indications-btn" type="button" @click="openDonora">
          <svg
            class="donora-indications-heart"
            viewBox="0 0 24 24"
            aria-hidden="true"
            focusable="false"
          >
            <path
              d="M12 21s-7.2-4.6-9.5-9C.6 8.4 2.6 4.5 6.4 4.1c2-.2 3.8.8 4.8 2.4 1-1.6 2.8-2.6 4.8-2.4 3.8.4 5.8 4.3 3.9 7.9C19.2 16.4 12 21 12 21z"
            />
          </svg>
          <span>{{ $t("pay.donoraCta") }}</span>
        </button>
      </div>

      <flashlight />

      <van-row v-if="showRate === true" class="payment-box mt-20">
        <van-col span="24">
          <div class="white-color center mb-15">{{ $t("settings.rate_now")}}</div>
          <itserve-button
              @click="runRate"
              type="primary"
              :value="$t('settings.rate_now_button')"
              class="mt-10"
          ></itserve-button>
        </van-col>
      </van-row>
      
<!--      <div class="array-block">-->
<!--        <div @click="webLink" class="block">-->
<!--            <icon :name="web" size="60" />-->
<!--        </div>-->
<!--      <div class="block">-->
<!--          <a href="https://t.me/GASUA_bot">-->
<!--          <icon :name="telegram" size="60" />-->
<!--          </a>-->
<!--        </div>-->
<!--        <div class="block">-->
<!--          <a href="viber://pa?chatURI=naftogazpostach">-->
<!--            <icon :name="viber" size="60" />-->
<!--          </a>-->
<!--        </div>-->
<!--      </div>-->
<!--      <template v-if="nativeData.id">-->
<!--      <template v-if="nativeData.id === 'kharkiv.gas'">-->
<!--        <KharkivGasSendIndication />-->
<!--      </template>-->
<!--        <template v-else-if="nativeData.id === 'kirovograd.gas'">-->
<!--          <template v-if="kirovogradGrmLs.success === true">-->
<!--            <van-col class="itserve-center mt-10" span="24">-->
<!--              <itserve-route-->
<!--                  :buttonName="$t('buttons.grmKirovograd')"-->
<!--                  route-name="SendIndications"-->
<!--                  type="wide"-->
<!--              ></itserve-route>-->
<!--            </van-col>-->
<!--          </template>-->
<!--          <template v-else>-->
<!--          <AddGrmLs />-->
<!--          </template>-->
<!--        </template>-->
<!--      </template>-->
    </van-col>
  </van-row>
</template>
<script>
import Flashlight from "@/components/indications/Flashlight";
// import {Icon} from "vant";
import InfoMessage from "@/components/content/InfoMessage";
import SendIndicationsInfoPart from "@/components/indications/SendIndicationsInfoPart";
// import KharkivGasSendIndication from "@/components/contacts/KharkivGasSendIndication";
// import AddGrmLs from "@/components/grm/kirovograd/AddGrmLs";
// import ItserveRoute from "@/components/content/ItserveRoute";
import ApiNaftogazTariffmaxForm from '@/components/indications/ApiNaftogazTariffmaxForm';
import ItserveButton from '@/components/forms/ItserveButton';
import { getDonoraUrl } from "@/views/account/edopomoga/donoraLinks";
export default {
  name: "SendIndicationContacts",
  components: {
    Flashlight,
    //  KharkivGasSendIndication,
    //  AddGrmLs,
    //  ItserveRoute,
     SendIndicationsInfoPart,
     InfoMessage,
    ApiNaftogazTariffmaxForm,
    ItserveButton,
  },
  data() {
    return {
      phone: process.env.VUE_APP_CALL_PHONE,
      email: process.env.VUE_APP_SUPPORT_EMAIL,
      phone_view: process.env.VUE_APP_PHONE_VIEW,
      showRate: false,
    }
  },
  computed: {
    web() {
      return require('@/assets/images/link.png');
    },
    telegram() {
      return require('@/assets/images/free-icon-telegram-2111646.png');
    },
    viber() {
      return require('@/assets/images/free-icon-viber-3938039.png');
    },
    lastIndicators() {
      return this.$store.state.RegionalEnergy.lastIndicators;
    },
    kirovogradGrmLs() {
      return this.$store.state.Grm.lsInfo;
    },
    nativeData() {
      return this.$store.state.Auth.nativeData;
    },
    account() {
      return this.$store.state.Auth.account;
    },
    submitResult() {
      return this.$store.state.ApiNaftogazTariffmax.submitResult;
    },
  },
  watch: {
    submitResult(newValue) {
      console.log("CHLENIX WATCH ", newValue)
      // Здесь можно запустить логику после успешной отправки
      if (newValue.status === "pending") {
        this.showRate = true;
      }
  },
},
  created() {
    console.log("CHLENIX SEND METRIC ", JSON.stringify(this.$store.state.Auth.account));
  },
  methods: {
    openDonora() {
      const link = getDonoraUrl(this.$store.state.Auth.app_id);

      if (typeof this.nativeSendEvent === "function") {
        this.nativeSendEvent("url", link);
        return;
      }

      window.open(link, "_blank", "noopener");
    },
    runRate() {
      let id;
      let url;

      id = this.$store.state.Auth.app_id;
      switch (id) {
        case "zaporizhzhia.gas":
          url = "https://billing.city/zaporizhzhia.gas";
          break;
        case "lviv.gas":
          url = "https://billing.city/lviv.gas";
          break;
        case "volyn.gas":
          url = "https://billing.city/volyn.gas";
          break;
        case "kherson.gas":
          url = "https://billing.city/kherson.gas";
          break;
        case "ternopil.gas":
          url = "https://billing.city/ternopil.gas";
          break;
        case "chernivtsi.gas":
          url = "https://billing.city/chernivtsi.gas";
          break;
        case "prykarpattya.gas":
          url = "https://billing.city/prykarpattya.gas";
          break;
        case "zakarpattya.gas":
          url = "https://billing.city/zakarpattya.gas";
          break;
        case "rivne.gas":
          url = "https://billing.city/rivne.gas";
          break;
        case "khmelnytskyi.gas":
          url = "https://billing.city/khmelnytskyi.gas";
          break;
        case "vinnytsia.gas":
          url = "https://billing.city/vinnytsia.gas";
          break;
        case "cherkasy.gas":
          url = "https://billing.city/cherkasy.gas";
          break;
        case "chernihiv.gas":
          url = "https://billing.city/chernihiv.gas";
          break;
        case "mykolaiv.gas":
          url = "https://billing.city/mykolaiv.gas";
          break;
        case "dnipro.gas":
          url = "https://billing.city/dnipro.gas";
          break;
        case "poltava.gas":
          url = "https://billing.city/poltava.gas";
          break;
        case "odesa.gas":
          url = "https://billing.city/odesa.gas";
          break;
        case "zhytomyr.gas":
          url = "https://billing.city/zhytomyr.gas";
          break;
        case "kirovograd.gas":
          url = "https://billing.city/kirovograd.gas";
          break;
        case "sumy.gas":
          url = "https://billing.city/sumy.gas";
          break;
        case "kyiv.gas":
          url = "https://billing.city/kyiv.gas";
          break;
        case "kharkiv.gas":
          url = "https://billing.city/kharkiv.gas";
          break;
        default:
          url = "https://billing.city";
      }

      this.nativeSendEvent("url", url);
    },
    webLink() {
      this.nativeSendEvent("url", "https://gas.ua/uk/indicators");
    }
  },
};
</script>
<style scoped>
@import "../../../../node_modules/vant/lib/cell/index.css";
h5 {
  margin: 0;
  text-align: center;
  font-size: 18px;
  color: #0b0b0b;
}
.icon {
  --van-cell-icon-size: 40px;
}
.array-block {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.block {
  width: 100px;
  display: inline-block;
  text-align: center;
}

.white-color {
  color: #fff;
}

.donora-indications-action {
  position: relative;
  width: min(337px, 100%);
  margin: 20px auto 14px;
  padding-top: 16px;
}

.donora-indications-action::before {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  width: 88px;
  height: 2px;
  border-radius: 999px;
  background: rgba(143, 156, 180, 0.28);
  transform: translateX(-50%);
}

.donora-indications-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  min-height: 52px;
  padding: 13px 24px;
  border: 0;
  border-radius: 12px;
  background: linear-gradient(135deg, #2f5fd3 0%, #4779f7 100%);
  color: #ffffff;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
}

.donora-indications-heart {
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
  fill: none;
  stroke: #ffffff;
  stroke-width: 2;
  animation: donora-indications-heart-pulse 1.35s ease-in-out infinite;
}

@keyframes donora-indications-heart-pulse {
  0%,
  100% {
    transform: scale(1);
  }

  45% {
    transform: scale(1.14);
  }
}
</style>
